// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Input for setting a value override on any OPC UA browse path
 * @export
 * @interface ValueOverrideInput
 */
export interface ValueOverrideInput {
    /**
     * Full OPC UA browse path (e.g. DeviceSet/SP2DC800200/HierarchicalLocation)
     */
    browsePath: string;
    /**
     * The override value
     */
    value: any | null;
    /**
     * OPC UA data type name (e.g. String, Double, Boolean)
     */
    dataType: string;
    /**
     * OPC UA reference type
     */
    referenceType: ValueOverrideInputReferenceTypeEnum;
}


/**
 * @export
 */
export const ValueOverrideInputReferenceTypeEnum = {
    Property: 'property',
    Variable: 'variable'
} as const;
export type ValueOverrideInputReferenceTypeEnum = typeof ValueOverrideInputReferenceTypeEnum[keyof typeof ValueOverrideInputReferenceTypeEnum];


/**
 * Check if a given object implements the ValueOverrideInput interface.
 */
export function instanceOfValueOverrideInput(value: object): value is ValueOverrideInput {
    if (!('browsePath' in value) || value['browsePath'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('dataType' in value) || value['dataType'] === undefined) return false;
    if (!('referenceType' in value) || value['referenceType'] === undefined) return false;
    return true;
}

export function ValueOverrideInputFromJSON(json: any): ValueOverrideInput {
    return ValueOverrideInputFromJSONTyped(json, false);
}

export function ValueOverrideInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValueOverrideInput {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'],
        'value': json['value'],
        'dataType': json['dataType'],
        'referenceType': json['referenceType'],
    };
}

export function ValueOverrideInputToJSON(json: any): ValueOverrideInput {
    return ValueOverrideInputToJSONTyped(json, false);
}

export function ValueOverrideInputToJSONTyped(value?: ValueOverrideInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'value': value['value'],
        'dataType': value['dataType'],
        'referenceType': value['referenceType'],
    };
}

